'use client';

import React from 'react';
import Loader from '@/components/ui/loader';

interface DataTableColumn {
  key: string;
  label: string;
}

interface DataTableProps {
  columns: DataTableColumn[];
  children: React.ReactNode;
  loading?: boolean;
  isEmpty?: boolean;
  emptyMessage?: string;
  loadingMessage?: string;
}

export const DataTable: React.FC<DataTableProps> = ({
  columns,
  children,
  loading = false,
  isEmpty = false,
  emptyMessage = 'No data available.',
  loadingMessage = 'Loading data...',
}) => {
  const colSpan = Math.max(columns.length, 1);

  return (
    <div className="w-full overflow-x-auto bg-white">
      <table className="w-full min-w-160">
        <thead>
          <tr className="border-b border-slate-200 bg-[linear-gradient(180deg,#f8fbff_0%,#edf4ff_100%)]">
            {columns.map((col) => (
              <th
                key={col.key}
                className="whitespace-nowrap px-4 py-3 text-left text-[11px] font-bold uppercase tracking-widest text-slate-700"
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100 bg-white font-bold capitalize">
          {loading ? (
            <tr>
              <td colSpan={colSpan} className="px-4 py-10">
                <div className="flex flex-col items-center justify-center gap-3 text-center text-sm text-gray-500">
                  <Loader className="scale-50" />
                  <span>{loadingMessage}</span>
                </div>
              </td>
            </tr>
          ) : isEmpty ? (
            <tr>
              <td colSpan={colSpan} className="px-4 py-10 text-center text-sm font-medium text-gray-500">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            children
          )}
        </tbody>
      </table>
    </div>
  );
};
